import { useEffect } from 'react';
import { useHover } from './useHover.js';

function useHoverCardVideoPlay(hoverContainerRef, assetVideoChild, assetVideoRef) {
  var isHovering = useHover(hoverContainerRef);
  useEffect(function () {
    var _assetVideoChild$prop;
    var hasAssetVideo = Boolean(assetVideoChild);
    if (!hasAssetVideo) return;
    var shouldPlayOnHover = hasAssetVideo && (assetVideoChild === null || assetVideoChild === void 0 || (_assetVideoChild$prop = assetVideoChild.props) === null || _assetVideoChild$prop === void 0 ? void 0 : _assetVideoChild$prop.playOnCardHover);
    if (!shouldPlayOnHover) return;
    if (isHovering) {
      var _assetVideoRef$curren;
      assetVideoRef === null || assetVideoRef === void 0 || (_assetVideoRef$curren = assetVideoRef.current) === null || _assetVideoRef$curren === void 0 ? void 0 : _assetVideoRef$curren.play();
    } else {
      var _assetVideoRef$curren2;
      assetVideoRef === null || assetVideoRef === void 0 || (_assetVideoRef$curren2 = assetVideoRef.current) === null || _assetVideoRef$curren2 === void 0 ? void 0 : _assetVideoRef$curren2.pause();
    }
  }, [isHovering, assetVideoChild, assetVideoRef]);
}

export { useHoverCardVideoPlay };
//# sourceMappingURL=useHoverCardVideoPlay.js.map
